import "./src/styles/global.css"

/*
 * SPA 路由切换时手动上报页面浏览。
 * Umami 脚本会拦截带 data-umami-event 的元素点击，无需手动埋点。
 */
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && window.umami) {
    window.umami.track((props) => ({ ...props, url: location.pathname }))
  }
}
